import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Calendar, ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FestivalOverview() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section data-section-id="35677" id="introducción-al-curso-de-barbería" className="relative h-screen w-full overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay muted loop playsInline poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/tech_festival_hero_poster.png" className="h-full w-full object-cover opacity-50 contrast-125 brightness-75">
          {}
          <source src="/videos/tech_pulse_loop.mp4" type="video/mp4" />
        </video>
        
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-background" />
        
        {}
        <div className="absolute inset-0 bg-[linear-gradient(rgba(251,191,36,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(251,191,36,0.03)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_at_center,black_40%,transparent_80%)]" />
      </div>

      {}
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center sm:px-6 lg:px-8">
        <div ref={textRef} className={`flex flex-col items-center gap-6 transition-all duration-1000 ease-out ${textVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          {}
          <div className="inline-flex items-center gap-2 rounded-full border border-secondary/30 bg-secondary/10 px-4 py-1.5 text-sm font-bold uppercase tracking-widest text-secondary backdrop-blur-md">
            <SafeHydrate><Calendar className="h-4 w-4" /></SafeHydrate>
            <span>Inscripciones Abiertas 2025</span>
          </div>

          {}
          <h1 className="max-w-5xl text-5xl font-black tracking-tighter text-white sm:text-7xl md:text-8xl lg:text-9xl">
            <span className="block text-transparent bg-clip-text bg-gradient-to-b from-white to-white/60">
              MAESTRÍA EN
            </span>
            <span className="block font-serif italic text-transparent bg-clip-text bg-gradient-to-r from-secondary via-amber-400 to-secondary bg-[length:200%_auto] animate-[gradient_4s_linear_infinite]">
              BARBERÍA
            </span>
          </h1>

          {}
          <p className="max-w-2xl text-lg text-muted-foreground md:text-xl font-medium">
            Domina el arte del corte clásico y las tendencias urbanas más exigentes. 
            Fórmate con profesionales y conviértete en un barbero de élite con ECAP.
          </p>
        </div>

        {}
        <div ref={ctaRef} className={`mt-12 transition-all duration-1000 delay-300 ease-out ${ctaVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <Button asChild size="lg" className="group relative h-14 overflow-hidden rounded-full border border-secondary/50 bg-secondary/10 px-8 text-lg font-bold text-white backdrop-blur-sm transition-all hover:bg-secondary hover:text-secondary-foreground hover:shadow-[0_0_40px_rgba(251,191,36,0.6)] hover:scale-105">
            
          </Button>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce text-secondary/50">
        <ArrowDown className="h-6 w-6" />
      </div>
    </section>;
}